// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1e9Nz","inner":"Form_inner__1ZKuJ","range":"Form_range__2cnbE","name":"Form_name__1xa1S","actions":"Form_actions__2iNyM"};